import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router'

import { Button, ButtonRow, FilterButton } from '../buttons'
import { Details, Row, Block } from '../details/details'
import { Tab, TabPanel, TabList, Tabs } from 'react-tabs'

import WorkTrackersSummary from './work-trackers-summary'
import AreaCardContainer from '../../containers/areas/area-card-container'
import AreaWorkTrackerSearch from '../../components/areas/area-work-tracker-search'
import TechnicianWorkSummaryDetails from '../../components/technician-work-summaries/technician-work-summary-details'

import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'

import premiumAccess from '../../images/premium3.png'

const ClearButton = ({ action }) => (
  <span style={{
    textTransform: 'none',
    fontSize: '0.8em',
    textDecoration: 'underline',
    cursor: 'pointer',
    paddingLeft: '3px',
  }} onClick={action}>clear</span>
)

function downloadCSVButton (params, action, disabled, style = { position: 'absolute', top: '2px', right: '2px' }) {
  var label = 'Download'

  return (
    <Button
      onClick={(event) => action(params)}
      className={cx('extra-small', 'action-button', 'download', { disabled })}
      style={style}
      disabled={disabled}
    />
  )
}

const WorkTrackerDetails = ({
  locationModel = {},
  locationModel: {
    finishedLoadingContracts = false,
    finishedLoadingWorkTrackers = false,
    finishedLoadingAreas = false,
    finishedLoadingTechnicianWorkSummaries = false,
  } = {},
  workTrackers = [],
  areas = [],
  technicianWorkSummaries = [],
  goToServicingVersions = () => {},

  location: { pathname } = {},
  contractedServices,
  contractDates,
  contractId,
  contractProgress,
  appliedFilters,
  appliedFilters: {
    datePeriod: {
      startPeriod,
      endPeriod
    } = {}
  },
  emptyFilters = true,
  singleServiceSelected = false,

  clearAreaTypeFilter,
  clearSubLocationFilter,
  clearServiceFilter,
  clearAmountFilter,
  clearDatePeriodFilter,
  clearLastCleanedFilter,

  updateLastCleanedFilter,

  csvDownload,
  requestWorkTrackerReport,
  downloadWorkTrackerSingleServiceReport,

  onTabSelect,
  selectedTab,

  searchQuery,
  onSearch,

  hasMoreAreas,
  onLoadNextPage,

  enableAmountAndSort,
  enableAmount,
  userType,

  children
}) => {
  let clearAreaTypeButton = null
  let clearSubLocationButton = null
  let clearServiceButton = null
  let clearAmountButton = null
  let clearDatePeriodButton = null
  let clearLastCleanedButton = null

  let contractedServicesComponent = finishedLoadingContracts ?  <p>No contracted services found</p> : <p>Loading...</p>

  if (appliedFilters.areaType) {
    clearAreaTypeButton = <ClearButton action={clearAreaTypeFilter} />
  }

  if (appliedFilters.subLocation) {
    clearSubLocationButton = <ClearButton action={clearSubLocationFilter} />
  }

  if (appliedFilters.service) {
    clearServiceButton = <ClearButton action={clearServiceFilter} />
  }

  if (appliedFilters.amount) {
    clearAmountButton = <ClearButton action={clearAmountFilter} />
  }

  if (appliedFilters.datePeriod) {
    clearDatePeriodButton = <ClearButton action={clearDatePeriodFilter} />
  }

  if (appliedFilters.lastCleaned) {
    clearLastCleanedButton = <ClearButton action={clearLastCleanedFilter} />
  }

  if (contractedServices && contractedServices.length > 0) {
    contractedServicesComponent = contractedServices.map((service, i) => <p key={i}>{service}</p>)
  }

  let technicianTabContent = (
    <TechnicianWorkSummaryDetails
    technicianWorkSummaries={technicianWorkSummaries}
    location={locationModel}
    finishedLoading={finishedLoadingTechnicianWorkSummaries}
    goToServicingVersions={goToServicingVersions}
    contractId={contractId}
    />
  )
  let isSupervisor = false
  let premiumImg = null
  if (userType === 'Supervisor') {
    isSupervisor = true
    technicianTabContent = (<p>Please e-mail <a href='mailto:info@maatsapp.com'>info@maatsapp.com</a> to upgrade your service.</p>)
    premiumImg = (<img src={premiumAccess} className='premium' alt='premiumAccess' width={18} height={18} />)
  }

  return (
    <div>
      <Details>
        <Row>
          <Block title='location'>
            <p>{locationModel.name}</p>
          </Block>
          <Block title='Time Period' to={`${pathname}/filter-contract`}>
            <p>{finishedLoadingContracts ? contractDates : 'Loading...'}</p>
          </Block>
        </Row>
        <Row>
          <Block title="Report Builder" style={{ position: 'relative' }}>
            <div style={{display: 'flex', position: 'relative', height: '35px', marginBottom: '10px', alignItems: 'center'}}>
              <p>All Services</p>
              {contractId &&
                downloadCSVButton(contractId, requestWorkTrackerReport, !emptyFilters, { position: 'absolute', right: '0px' } )
              }
              <Tooltip
                overlay={<span>Work Tracker historical reports</span>}
                placement='left'>
                <Button
                  to="/reports"
                  className={cx('extra-small', 'action-button', 'reports')}
                  style={{position: 'absolute', right: '35px'}}
                />
              </Tooltip>
            </div>

            <FilterButton to={`${pathname}/filter-room-type`} title="Area Type">
              {appliedFilters.areaType || 'All'} {clearAreaTypeButton}
            </FilterButton>
            <FilterButton to={`${pathname}/filter-sub-location`} title="Sub-Location">
              {appliedFilters.subLocation || 'All'} {clearSubLocationButton}
            </FilterButton>
            <FilterButton to={`${pathname}/filter-service`} title="Service">
              {appliedFilters.service || 'All'} {clearServiceButton}
            </FilterButton>
            <FilterButton to={`${pathname}/filter-date-period`} title="Date Range">
              {appliedFilters.datePeriod ?
                `${startPeriod.format('MMM Do, YYYY')} - ${endPeriod.format('MMM Do, YYYY')}`
                : 'All'} {clearDatePeriodButton}
            </FilterButton>
            <FilterButton
              renderButton={
                <Tooltip
                  overlay={<span>Select a single service</span>}
                  placement='left'
                  trigger={!singleServiceSelected ? ['hover'] : []}>
                  <Button
                    style={{flex: 1, padding: '3px 5px', marginRight: '5px'}}
                    small
                    disabled={!singleServiceSelected}
                    to={`${pathname}/filter-amount`}>
                    Amounts
                  </Button>
                </Tooltip>
              }
            >
              {appliedFilters.amount || 'All (completed)'} {clearAmountButton}
            </FilterButton>
            <FilterButton
              renderButton={
                <Tooltip
                  overlay={<span>Most Needed</span>}
                  placement='left'
                  trigger={!singleServiceSelected ? ['hover'] : []}>
                  <Button
                    style={{flex: 1, padding: '3px 5px', marginRight: '5px'}}
                    small
                    disabled={!singleServiceSelected}
                    onClick={() => {
                      updateLastCleanedFilter((appliedFilters.lastCleaned) ? null : 'On')
                    }}
                    >
                    Most Needed
                  </Button>
                </Tooltip>
              }
            >
              {appliedFilters.lastCleaned || 'Off'} {clearLastCleanedButton}
            </FilterButton>
            <div style={{display: 'flex', position: 'relative', height: '50px', alignItems: 'center'}}>
              <p style={{padding: 0}}>Applied Filters</p>
              {contractId &&
              <Tooltip
                overlay={emptyFilters ? (<span>Apply at least one filter</span>) : (<span>Option not available for Most Needed</span>)}
                placement='bottom'
                trigger={(emptyFilters || appliedFilters.lastCleaned) ? ['hover'] : []}>
                {downloadCSVButton(contractId, requestWorkTrackerReport, emptyFilters || appliedFilters.lastCleaned, { position: 'absolute', right: '0px' } )}
              </Tooltip>}
              {contractId &&
              <Tooltip
                overlay={<span>Select a single service</span>}
                placement='bottom'
                trigger={!singleServiceSelected ? ['hover'] : []}>
                {downloadCSVButton(contractId, downloadWorkTrackerSingleServiceReport, !singleServiceSelected, { position: 'absolute', right: '35px', ...singleServiceSelected && { backgroundColor: '#109E9A' } } )}
              </Tooltip>}
            </div>

          </Block>
          <Block title='Required Services' style={{ position: 'relative' }}>
            {contractId && downloadCSVButton(contractId, csvDownload, false, { position: 'absolute', top: '2px', right: '2px', backgroundColor: '#109E9A' })}
            {contractedServicesComponent}
          </Block>
        </Row>
        <Row>
          <Block title='Time Period Progress'>
            <div className='contract-progress-container'>
              <div className='contract-progress' style={{ width: `${contractProgress}%` }}></div>
            </div>
            <p className='contract-progress-percentage'>{contractProgress}%</p>
          </Block>
        </Row>
      </Details>

      <Tabs onSelect={onTabSelect} selectedIndex={selectedTab}>
        <TabList>
          <Tab>Summary</Tab>
          <Tab>Areas</Tab>
          <Tab disabled={isSupervisor} className={isSupervisor ? 'disabled' : ''}>
            Technicians&nbsp;
            {premiumImg}
          </Tab>
        </TabList>

        <TabPanel className='list'>
          <WorkTrackersSummary
            workTrackers={workTrackers}
            finishedLoading={finishedLoadingWorkTrackers}
          />
        </TabPanel>

        <TabPanel className='list'>
          <AreaWorkTrackerSearch
            placeholder='Search areas...'
            defaultValue={searchQuery}
            onChange={(event) => {
              locationModel.finishedLoadingAreas = false
              onSearch(event)
            }} />

          {areas.length == 0 && !finishedLoadingAreas && 'Loading...'}
          {areas.map(area =>
            <AreaCardContainer key={area.id} linkUrlBase={pathname} areaId={area.id} />
          )}

          {hasMoreAreas &&
            <div className='card load-more' onClick={onLoadNextPage}>
              Load more...
            </div>}
        </TabPanel>

        <TabPanel className='list'>
            {technicianTabContent}
        </TabPanel>
      </Tabs>

      {children}
    </div>
  )
}

export default WorkTrackerDetails



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-tracker-details.js